const header = {
  el: $(".header"),

  init: function () {
    this.languages();
    this.page_scroll();

    this.mobile.init();
    header.sub_menu.init();
  },

  languages: function () {
    $(".languages__toggle").on("click", function (e) {
      e.preventDefault();
      let btn = $(this);
      btn.toggleClass("languages__toggle-open");
      btn.next().slideToggle(250);
    });
  },

  page_scroll: function () {
    // On page load
    let hash = window.location.hash;
    if (hash) {
      setTimeout(function () {
        header.go_to(hash);
      }, 250);
    }
    // On nav click
    $(".header a").on("click", function (e) {
      let curr_loc = window.location.origin + window.location.pathname;
      let href = $(this).attr("href");
      let hash_array = href.split("#");
      // Check if # is there
      // Make sure we are on correct page
      if (hash_array[0] == curr_loc) {
        e.preventDefault();
        let el = null,
          target = null;
        if (hash_array.length > 1) {
          let hash = hash_array.pop();
          el = "#" + hash;
          target = el;
        } else {
          el = "body";
          target = "";
        }
        if ($(window).width() < 1200) {
          header.mobile.close();
        }
        header.go_to(el);
        window.location.hash = target;
      }
    });
  },

  mobile: {
    init: function () {
      // First call.
      this.menu_size();

      // On resize.
      $(window).on("resize", function () {
        header.mobile.menu_size();
      });

      // Toggle menu
      header.el.find(".toggle-menu").on("click", function (e) {
        e.preventDefault();
        if ($(this).hasClass("active")) {
          header.mobile.close();
        } else {
          header.mobile.open();
        }
      });
    },

    menu_size: function () {
      $(".header .qcf").css("top", 0);
      $(".header__right").css("height", "auto");
      header.el.removeClass("header--mobile-open");
    },

    close: function () {
      header.el.find(".toggle-menu").removeClass("active");
      if (header.el.hasClass("header--scrolled")) {
        header.el.removeClass("header--was-scrolled");
      }
      header.el.removeClass("header--mobile-open");
      $("html").removeClass("no-scroll");
    },

    open: function () {
      header.el.find(".toggle-menu").addClass("active");
      if (!header.el.hasClass("header--scrolled")) {
        header.el.addClass("header--was-scrolled");
      }
      header.el.addClass("header--mobile-open");
      $("html").addClass("no-scroll");
    },
  },

  sub_menu: {
    init: function () {
      this.visibility();
      // On resize.
      $(window).on("resize", function () {
        header.sub_menu.visibility();
      });

      // Submenu functionality
      header.el.find(".menu-item__toggle-submenu").on("click", function (e) {
        e.preventDefault();
        let btn = $(this);

        if (btn.parent().hasClass("open") && $(window).width() < 1200) {
          header.sub_menu.toggle(btn, "close");
        } else {
          header.sub_menu.toggle(btn, "open");
        }
      });

      // Close submenu.
      header.el.find(".sub-menu a").on("click", function () {
        let btn = $(this);
        if ($(window).width() < 1200) {
          let parent = btn.closest(".menu-item-has-children").children("a");
          header.sub_menu.toggle(parent, "close");
        }
      });
    },

    toggle: function (btn, action) {
      let parent = btn.parent();
      let siblings = parent.siblings();

      if ($(window).width() < 1200) {
        siblings.removeClass("open");
        siblings.children(".sub-menu").slideUp();

        if (action == "open") {
          parent.addClass("open");
          parent.children(".sub-menu").slideDown();
        } else if (action == "close") {
          parent.removeClass("open");
          parent.children(".sub-menu").slideUp();
        }
      }
    },

    visibility: function () {
      header.el.find(".menu-item__toggle-submenu").each(function () {
        let action = null;
        let btn = $(this);

        if ($(window).width() < 1200) {
          action = "close";
        } else {
          action = "open";
        }
        header.sub_menu.toggle(btn, action);
      });
    },
  },

  go_to: function (el) {
    if ($(el).length) {
      let offset = $(el).offset().top - $(".header").height();
      $("html, body").animate(
        {
          scrollTop: offset - 30,
        },
        250
      );
    }
  },
};
export default header;
